import { render } from "./TunsoftMain.vue?vue&type=template&id=2d38b669&scoped=true"
import script from "./TunsoftMain.vue?vue&type=script&lang=js"
export * from "./TunsoftMain.vue?vue&type=script&lang=js"

import "./TunsoftMain.vue?vue&type=style&index=0&id=2d38b669&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d38b669"]])

export default __exports__